import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OpenModal, setMainLoading, setPageTitle, setSupplierSearchKeyword } from "../../Store/reducers/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { Link } from "react-router-dom";
import Pagination from "../../Services/Pagination";
import { ConvertErrorArrayToString, getIntPost, getLocalPost, intl_posts, local_posts, MemberExportOptions } from "../../Services/Common";
import moment from "moment";
import { setToastData } from "../../Store/reducers/Toast";
import useConfirm from "../../Services/Confirmation";
import Modal from "../../Services/Modal";
import PieChart from "../../Services/Charts/PieChart";

const MembersList = () => {
    const dispatch = useDispatch();
    const customConfirm = useConfirm();
    const { userData, accessToken } = useSelector((state) => state.user);
    const { supplierSearchKeyword } = useSelector((state) => state.common);
    const [filter, setFilter] = useState({
        org_id: (supplierSearchKeyword.org_id > 0) ? supplierSearchKeyword.org_id : userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: (supplierSearchKeyword.div_id > 0) ? supplierSearchKeyword.div_id : (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") ? 0 : userData.user_div,
        search: (supplierSearchKeyword.searchText !== "") ? supplierSearchKeyword.searchText : '',
        designation: (supplierSearchKeyword.designation && supplierSearchKeyword.designation !== "") ? supplierSearchKeyword.designation : "all",
    });
    const [showFilter, setShowFilter] = useState(true);
    const [currentPage, setCurrentPage] = useState((supplierSearchKeyword.page_no > 0) ? supplierSearchKeyword.page_no : 1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 50 });
    const [memList, setMemList] = useState([]);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [profileCompletionChart, setProfileCompletionChart] = useState({});
    const [showExportOptions, setShowExportOptions] = useState(false);
    const [showProfileCompletionPP, setShowProfileCompletionPP] = useState(false);
    const [exportFields, setExportFields] = useState([]);
    const [selectedMemberIds, setSelectedMemberIds] = useState([]);
    const [exportMode, setExportMode] = useState("all");
    const [excludeCompleted, setExcludeCompleted] = useState(false);
    const [memberWise, setMemberWise] = useState(true);
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle(`Members`));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    runFilter();
                })
                .catch(err => {
                    console.log(err);
                })
        }
        else {
            runFilter();
        }
    }, [accessToken, dispatch])
    const runFilter = (pageNo = 0) => {
        dispatch(setMainLoading(true));
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`users`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setMemList(data.data);
                }
                else {
                    setPaginationData({ total: 0, per_page: 20 });
                    setMemList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId || orgId === 0) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList])
    const clearSelectedMembers = () => {
        setSelectedMemberIds([]);
    };
    const toggleMemberSelection = (memberId) => {
        const id = parseInt(memberId, 10);
        if (!id) return;
        setSelectedMemberIds((prev) => (
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        ));
    };
    const currentPageMemberIds = useMemo(() => memList.map((item) => parseInt(item.id, 10)).filter((id) => id > 0), [memList]);
    const isAllCurrentPageSelected = currentPageMemberIds.length > 0 && currentPageMemberIds.every((id) => selectedMemberIds.includes(id));
    const toggleSelectAllCurrentPage = () => {
        if (isAllCurrentPageSelected) {
            setSelectedMemberIds((prev) => prev.filter((id) => !currentPageMemberIds.includes(id)));
        } else {
            setSelectedMemberIds((prev) => [...new Set([...prev, ...currentPageMemberIds])]);
        }
    };
    const exportReport = () => {
        if (exportMode === "selected" && selectedMemberIds.length < 1) {
            dispatch(setToastData({ message: "Please select at least one member.", isHtml: true, type: "error", showCloseBtn: true }));
            return;
        }
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('org_id', filter.org_id);
        form_data.append('div_id', filter.div_id);
        form_data.append('designation', filter.designation);
        form_data.append('export_fields', JSON.stringify(exportFields));
        if (exportMode === "selected") {
            form_data.append('member_ids', JSON.stringify(selectedMemberIds));
        }
        form_data.append('token', accessToken);
        fetch(`${process.env.REACT_APP_API_URL}users/export-members`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
            .then(response => {
                // Get the blob from the response
                const blob = response.blob();
                // Get the headers from the response
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                let fileName = `all-members-list-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;//`all-members-list-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const deleteMember = async (mem_id) => {
        let userChoice = await customConfirm({
            description: `Do you want to delete this member?`,
        });
        if (!userChoice) {
            return;
        }
        dispatch(setMainLoading(true));
        PostAxios(`users/delete-members`, { mem_id }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    runFilter();
                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    useEffect(() => {
        runFilter(0);
    }, [supplierSearchKeyword.searchText]);
    const getProfileCompletion = async () => {
        dispatch(setMainLoading(true));
        PostAxios(`users/profile-completion-chart`, {
            org_id: filter.org_id,
            div_id: filter.div_id
        }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setProfileCompletionChart(data.data);
                    setShowProfileCompletionPP(true);
                    dispatch(OpenModal());
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const exportProfileReport = async () => {
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('org_id', filter.org_id);
        form_data.append('div_id', filter.div_id);
        form_data.append('exclude_completed', excludeCompleted ? 'yes' : 'no');
        form_data.append('member_wise', memberWise ? 'member_wise' : 'division_wise');
        form_data.append('token', accessToken);
        fetch(`${process.env.REACT_APP_API_URL}users/export-profile-completion-report`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
            .then(response => {
                // Get the blob from the response
                const blob = response.blob();
                // Get the headers from the response
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                let fileName = `all-members-list-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;//`all-members-list-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const sendReminder = async () => {
        dispatch(setMainLoading(true));
        PostAxios(`cron/add-job`, {
            'type': 'profile_completion_reminder',
            'type_id': JSON.stringify({'org_id': filter.org_id,'div_id':filter.div_id})
        }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return <>
        <div className="main-form-sec">
            <div className="top-right-btn p-0">
                {/* {selectedMemberIds.length > 0 &&
                    <div className="d-flex align-items-center flex-wrap">
                        <span>{selectedMemberIds.length} member(s) selected</span>
                        <button type="button" className="btn btn-blue ms-2 me-2" onClick={clearSelectedMembers}>Clear Selection</button>
                    </div>
                } */}
                {
                    (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain" || userData.role_slug === "div_admin") &&
                    <>
                        <button className="btn btn-blue me-2" onClick={() => { sendReminder() }} type="button">Send Reminder</button>
                    </>
                }
                {
                    (userData.role_slug === "super_admin" || userData.caps_list.includes('add_user')) && 
                    <Link
                        to={"/members/add"}
                        className="btn-blue btn br-0"
                    >
                        Add New
                    </Link>
                }
                <button type="button" className="btn btn-blue ms-2" onClick={() => { getProfileCompletion() }}>Profile Completion Report</button>
                {selectedMemberIds.length > 0 &&
                    <button type="button" className="btn btn-blue ms-2" onClick={() => {
                        setExportMode("selected");
                        setShowExportOptions(true);
                        dispatch(OpenModal());
                    }}>Export Selected ({selectedMemberIds.length})</button>
                }
                <button type="button" className="btn btn-blue ms-2" onClick={() => {
                    setExportMode("all");
                    setShowExportOptions(true);
                    dispatch(OpenModal());
                }}>Export to Excel</button>

            </div>
            <div className="top-reports-filter">
                <div className={`right-filter-sec`}>
                    <button className="filter-toggle" onClick={() => {
                        setShowFilter(!showFilter);
                    }}>
                        <i className="fa-solid fa-filter"></i>
                    </button>
                    <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                        {
                            userData.role_slug === "super_admin" &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => {
                                            setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })
                                            dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, org_id: e.target.value, div_id: 0 }))
                                        }}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Division</label>
                                <div className="static-items-outer">
                                    <select
                                        id="div_id"
                                        name="div_id"
                                        className="select-input"
                                        value={filter.div_id}
                                        onChange={(e) => {
                                            filterHandler("div_id", e.target.value)
                                            dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, div_id: e.target.value }))
                                        }}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        <div className={`report-filter-field`}>
                            <label className="select-input-outer">Search</label>
                            <div className="static-items-outer">
                                <input type="text" name="search" id="search" className="form-input" value={filter.search} placeholder="ITS/Name"
                                    onChange={(e) => {
                                        filterHandler("search", e.target.value);
                                        dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, searchText: e.target.value }))
                                    }} />
                            </div>
                        </div>
                        <div className="report-filter-field">
                            <label className="select-input-outer">Designation</label>
                            <div className="static-items-outer">
                                <select
                                    id="designation"
                                    name="designation"
                                    className="select-input"
                                    value={filter.designation}
                                    onChange={(e) => {
                                        filterHandler("designation", e.target.value);
                                        dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, designation: e.target.value }));
                                    }}
                                >
                                    <option value="all">All</option>
                                    <option value="officers">All Officers</option>
                                    {[...intl_posts, ...local_posts].map((item, index) => (
                                        <option key={`designation-${index}`} value={item.id}>{item.value}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); clearSelectedMembers(); runFilter(1); dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, page_no: 1 })) }}>Submit</button>
                    </div>
                </div>
            </div>
            
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: 50 }}>
                            <label className="container-checkbox">
                                <input
                                    type="checkbox"
                                    checked={isAllCurrentPageSelected}
                                    onChange={toggleSelectAllCurrentPage}
                                    title="Select all on this page"
                                />
                                <span className="checkmark"></span>
                            </label>
                            </th>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>ITS</th>
                            <th>Division</th>
                            <th>Mobile</th>
                            <th>Designation</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            memList.length > 0 && memList.map((item, index) => {
                                return <tr key={`user-id-${index}-${item.id}`}>
                                    <td>
                                    <label className="container-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedMemberIds.includes(parseInt(item.id, 10))}
                                            onChange={() => toggleMemberSelection(item.id)}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                    </td>
                                    <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                    <td>{item?.full_name.trim()}</td>
                                    <td>{item.user_its}</td>
                                    <td>{item.div_name}</td>
                                    <td>{item?.user_calling_code ? item?.user_calling_code : '+91'}{item?.user_mobile}</td>
                                    <td>{(item?.user_intl_post) ? getIntPost(item.user_intl_post) : (item?.user_local_post) ? getLocalPost(item.user_local_post) : 'Member'}</td>
                                    <td>
                                        {
                                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.caps_list.includes('edit_users')) &&
                                            <Link to={'/members/edit/'} state={{ member_id: item.id }} className="btn-blue btn btn-sm" title="Update Member">
                                                <i className="fa-solid fa-pen"></i>
                                            </Link>
                                        }
                                        {
                                            (userData.role_slug === "super_admin" || userData.caps_list.includes('delete_users')) &&
                                            <button className="btn btn-red btn-sm ms-2" title="Delete Member" onClick={() => {
                                                deleteMember(item.id);
                                            }}>
                                                <i className="fa-solid fa-trash-can"></i>
                                            </button>
                                        }
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    runFilter(page);
                    dispatch(setSupplierSearchKeyword({ ...supplierSearchKeyword, page_no: page }))
                }}
            />
        </div>
        {
            showExportOptions === true && <Modal classList="popup-main invoice-popup" style={{ maxWidth: 1200, width: '90%' }} onClose={() => {
                setShowExportOptions(false);
                setExportFields([]);
                setExportMode("all");
            }}>
                <h3 className="text-center">{exportMode === "selected" ? `Export Selected Members (${selectedMemberIds.length})` : "Choose Export Fields"}</h3>
                <div className="form-field-group mt-3" role="group" aria-labelledby="checkbox-group" style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", // Adjust columns based on container width
                    gap: "5px", // Add spacing between items
                }}>
                    {
                        Object.keys(MemberExportOptions).map((key, index) => {
                            return <label className="container-checkbox my-1" key={`export-options-${index}`} style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setExportFields([...exportFields, key]);
                                        } else {
                                            setExportFields(exportFields.filter(field => field !== key));
                                        }
                                    }}
                                    checked={exportFields.includes(key)}
                                    value={key}
                                />
                                <span className="checkmark"></span>
                                {MemberExportOptions[key]}
                            </label>
                        })
                    }
                </div>
                <hr />
                <div className="text-center">
                    <button type="button" className="btn btn-blue mt-3 ms-2" onClick={() => {
                        exportReport();
                    }}>Export to Excel</button>
                </div>
            </Modal>
        }
        {
            showProfileCompletionPP === true && <Modal classList="popup-main invoice-popup" style={{ maxWidth: 600, width: '90%' }} onClose={() => {
                setShowProfileCompletionPP(false);
            }}>
                <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }} className="my-3">
                    <div className="form-group">
                        <label className="container-checkbox">
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    setExcludeCompleted(e.target.checked);
                                }}
                                checked={excludeCompleted}
                            />
                            <span className="checkmark"></span>
                            Exclude Completed Profiles
                        </label>
                    </div>
                    {
                        (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                        <div className="form-group">
                            <label className="container-checkbox">
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        setMemberWise(e.target.checked);
                                    }}
                                    checked={memberWise}
                                />
                                <span className="checkmark"></span>
                                Member Wise
                            </label>
                        </div>
                    }
                </div>
                <div className="form-group text-center">
                    <button className="btn btn-blue ms-2" onClick={() => { exportProfileReport(); }} title="Export">Export Report</button>
                </div>
                <PieChart options={
                    {
                        title: {
                            text: `Profile Completion - ${profileCompletionChart.completion_percentage}%`,
                        },
                        series: [
                            {
                                name: "Profile Completion",
                                colorByPoint: true,
                                data: [
                                    {
                                        name: "Completed",
                                        y: profileCompletionChart.completed_fields,
                                        color: "#4caf50", // Green for completed
                                    },
                                    {
                                        name: "Incomplete",
                                        y: profileCompletionChart.total_fields - profileCompletionChart.completed_fields,
                                        color: "#f44336", // Red for incomplete
                                    },
                                ],
                            },
                        ]
                    }
                } />
            </Modal>
        }
    </>
}

export default MembersList;